import { styled } from '../../Utilities';
import { DialogFooterBase } from './DialogFooter.base';
import { getStyles } from './DialogFooter.styles';
export var DialogFooter = styled(DialogFooterBase, getStyles, undefined, { scope: 'DialogFooter' });
//# sourceMappingURL=DialogFooter.js.map